<template>
  <div id="app" class="body">
    <router-view></router-view>
  </div>
</template>

<script>


export default {
  name: 'App',
  created() {
    
   
  }

}
</script>

<style lang="less">
html,
body {
  margin: 0;
  padding: 0;
  /* overflow-y: hidden;
    overflow-x: hidden; */
  background-color: var(--bg-color);
  color: var(--text-color);
}

#app {
  /* overflow-y: hidden;
    overflow-x: hidden; */
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--text-color3);
  margin: 0;
  padding: 0;
}

.margin-top-sm {
  margin-top: 10px;
}

.text-left {
  text-align: left;
}

.flex {
  display: flex;
}

.flex-1 {
  flex: 1;
}

.flex-item-end {
  align-items: end;
}

.flex-justify-spacebetween {
  justify-content: space-between;
}

.flex-align-center {
  align-items: center;
}

.margin-top-20 {
  margin-top: 20px !important;
}

.block {
  display: block;
}

.relative {
  position: relative;
}

.text-center {
  text-align: center;
}

.w100 {
  width: 100%;
}

.el-select-dropdown {
  border-radius: 12px !important;
  /*   border-color: #141518 !important; */
  // background-color: #141518
}

.el-select-dropdown__list {
  padding: 8px 8px !important;
  /*   background-color: #141518; */

}

.el-select-dropdown__item {
  /*   color: #fff !important;
  height: 56px !important;
  line-height: 56px !important; */
}

.el-select-dropdown__item:hover {
  /*   border-radius: 12px;
  background-color: #1E1F25 !important; */
}



.el-date-picker__editor {
  /*  background-color: #1E1F25 !important; */
  /* 设置日期框的背景颜色 */
}

.el-picker-panel .el-date-picker__editor-wrap .el-input__inner {
  /*   background-color: #1E1F25 !important; */
}

/* 针对主题按钮（比如“确定”按钮）可能需要额外的样式 */

/* 修改日期时间选择器右下角按钮的背景色 */
.el-picker-panel__footer .el-button {
  /*   background-color: #1E1F25 !important; */
  /* 更改为所需的背景颜色 */
  /*   border-color: #1E1F25 !important; */
  /* 保持边框颜色与背景色一致 */
}

.el-picker-panel__body {
  /*  background-color: #1E1F25 !important; */
  /* 使用 !important 提高样式优先级 */
}

.el-picker-panel__footer {
  /*  background-color: #1E1F25 !important; */
  /* 设置底部按钮栏的背景颜色 */
}

.el-picker-panel__icon-btn.confirm {
  /*  background-color: #1E1F25 !important; */
  /* 设置确定按钮的背景颜色 */
}

ƒƒ .el-table .el-table__header-wrapper table thead tr th {
  /*  border-bottom-color: #282C38 !important; */
  /* 设置表头下的水平线颜色 */
}

.el-table .el-table__body-wrapper>table>tbody>tr>td {
  /*  border-bottom-color: #282C38 !important; */
  /* 设置水平分割线的颜色 */
}

.el-table .el-table__fixed-right .el-table__fixed-header-wrapper table thead tr th {
  /* border-bottom: 1px solid #282C38; */
  /* 修改为红色，示例颜色 */
  border-top-right-radius: 10px;
}

.el-table .el-table__fixed-right .el-table__fixed-body-wrapper tbody tr td {
  /*  border-bottom: 1px solid #282C38; */
  /* 修改为红色，示例颜色 */
}

.el-table__header-wrapper th {
  font-size: 14px;
  /* 调整字体大小 */
  font-weight: bold;
  /* 字体加粗 */
}

.el-table__body-wrapper tbody tr td {
  font-size: 12px;
  /* 调整为希望的字体大小 */
}

/* 针对表格的左上角 */
.el-table__header-wrapper tr:first-child th:first-child {
  border-top-left-radius: 10px
}

/* 针对表格的右上角 */
.el-table__header-wrapper tr:first-child th:last-child {
  border-top-right-radius: 10px !important;
}

.el-table__fixed-right::before,
.el-table__fixed::before {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 1px;
  /*  background-color: #282C38 !important; */
  z-index: 4;
}

.el-table__body tr.hover-row.current-row>td.el-table__cell,
.el-table__body tr.hover-row.el-table__row--striped.current-row>td.el-table__cell,
.el-table__body tr.hover-row.el-table__row--striped>td.el-table__cell,
.el-table__body tr.hover-row>td.el-table__cell {
  /* background-color: #141518 !important; */
  /* 或使用您更倾向的黑色调色值 */
}
</style>
